import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ChartModule } from 'primeng/chart';
import { NumberPipe } from '../../../shared/pipes/number.pipe';

interface ProtocolForecastData {
  remainingBudget: number;
  totalBudget: number;
}

interface ForecastDataItem {
  day: string;
  dayEpoch: number;
  remainingDays: number;
  pdppAmount: number;
  activePatients: number;
  dailyNeed: number;
  totalOrderAmount: number;
  totalInvoiceAmount: number;
  forecastAmount: number;
  pcChanged: boolean;
  budget: number;
}

interface ForecastData {
  forecastData: ForecastDataItem[];
  totalEPCount: number;
  siteEPCount: number;
  totalBudget: number;
  siteBudget: number;
  savings: number;
  totalAPCount: number;
  totalSiteCount: number;
  usedBudget: number;
  remainingBudget: number;
}

@Component({
  selector: 'app-remaining-budget-vs-po',
  standalone: true,
  imports: [ChartModule],
  templateUrl: './remaining-budget-vs-po.component.html',
  styleUrl: './remaining-budget-vs-po.component.scss'
})
export class RemainingBudgetVsPOComponent implements OnChanges {
  @Input() protocolForecastData: ProtocolForecastData | null = null;
  @Input() forecastData: ForecastData | null = null;

  purchaseOrder = 0;
  remainingBudget = 0;
  total = 0;
  formattedPurchaseOrder = '$0.00k';
  formattedRemainingBudget = '$0.00k';
  formattedTotal = '$0.00k';
  data = {
    labels: ['Purchase Order', 'Remaining Budget'],
    datasets: [
      {
        data: [0, 1],
        backgroundColor: ['transparent', '#B2E1D8'],
        borderWidth: 0,
        borderRadius: [0, 20]
      } as any
    ]
  };
  options = {
    cutout: '70%',
    plugins: {
      legend: { display: false },
      tooltip: { enabled: false }
    },
    responsive: true,
    maintainAspectRatio: false
  };

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.forecastData && this.forecastData) {
      this.updateChartData();
    }
  }

  private updateChartData(): void {
    if (!this.forecastData) return;

    this.remainingBudget = Number(this.forecastData.remainingBudget.toFixed(2));
    this.total = Number(this.forecastData.totalBudget.toFixed(2));

    const totalOrderAmount = Number(this.forecastData.usedBudget.toFixed(2));
    this.purchaseOrder = Number(totalOrderAmount.toFixed(2));

    const numberPipe = new NumberPipe();
    this.formattedPurchaseOrder = `$${numberPipe.transform(this.purchaseOrder)}`;
    this.formattedRemainingBudget = `$${numberPipe.transform(this.remainingBudget)}`;
    this.formattedTotal = `$${numberPipe.transform(this.total)}`;

    this.data = {
      labels: ['Purchase Order', 'Remaining Budget'],
      datasets: [
        {
          data: [this.purchaseOrder, this.remainingBudget],
          backgroundColor: ['#65C9BB', '#B2E1D8'],
          borderWidth: 0,
        } as any
      ]
    };
  }
}
